import { takeLatest, call, put, select, spawn } from 'redux-saga/effects';
import analytics from '../../../utils/analytics';
import axios from '../axiosConfig';
import {
  getTripConfirmationRequest,
  getTripConfirmationSuccess,
  getTripConfirmationFailure,
  setCruiseItineraryPaymentAmount,
} from '../../slices/trip';
import { setCruiseSearchInputs, setCruiseSearchParam } from '../../slices/tripSearch';
import { setArchRoamAgentId } from '../../slices/user';

import getFiltersFromTrip from '../../../helpers/getFiltersFromTrip';

function* getTripConfirmationWorker({ payload: { tripId, form } }) {
  try {
    const { isLoggedIn, email } = yield select((store) => store.user);

    const url = '/trips/getConfirmation';
    let accessToken;
    let debug;
    if (window.location.search.indexOf('token=') > -1)
      accessToken = decodeURIComponent(window.location.search.split('token=')[1].split('&')[0]);
    if (isLoggedIn && email && email.endsWith && email.endsWith('@travelwits.com')) debug = true;
    const dataPayload = {
      tripId,
      ...(form || {}),
      debug,
    };

    const config = {
      method: 'post',
      url,
      data: JSON.stringify(dataPayload),
      headers: {
        'Content-Type': 'application/json',
        accessToken,
      },
    };
    const { data } = yield call(axios, config);

    if (data) {
      const searchObj = {
        filters: getFiltersFromTrip(data.trip),
        staterooms: getFiltersFromTrip(data.trip).staterooms,
      };
      yield put(setCruiseSearchParam(searchObj));
      yield put(setCruiseSearchInputs(searchObj));

      if (data.archRoamAgentId) {
        yield put(setArchRoamAgentId(data.archRoamAgentId));
      }

      const { travelAgency } = yield select((store) => store.user);
      yield put(
        getTripConfirmationSuccess({
          tripConfirmation: data,
          travelAgency,
          error: null,
        }),
      );
      if (data.tripId) {
        yield put(
          setCruiseItineraryPaymentAmount({
            tripConfirmation: data,
          }),
        );
      }
    } else {
      yield put(getTripConfirmationFailure(`Trip confirmation not found related to ${tripId}.`));
    }
  } catch (error) {
    yield spawn([analytics, 'track'], 'getTripConfirmationFailure', {
      tripId,
      status: error.response?.status,
    });

    const problemDetails = error.response?.data;
    const failureMessage = problemDetails?.title
      ? `${problemDetails.title} ${problemDetails.detail}`
      : 'Could not load the trip confirmation. Please try again.';
    yield put(getTripConfirmationFailure(failureMessage));
  }
}

function* getTripConfirmationWatcher() {
  yield takeLatest(getTripConfirmationRequest.toString(), getTripConfirmationWorker);
}

export default getTripConfirmationWatcher;
